import api, { API } from "@/lib/api";
import { safeNextPath, stashGoogleReturnPath } from "@/lib/safeNext";

/** Provider selection comes from this environment's backend, never a URL flag. */
export async function googleSignInUrl(nextPath, origin = window.location.origin) {
  const next = safeNextPath(nextPath);
  const { data } = await api.get("/auth/google/config", { timeout: 10000 });
  if (data?.provider === "direct") {
    const query = new URLSearchParams({ next, frontend_origin: origin });
    return `${API}/auth/google/start?${query.toString()}`;
  }
  if (data?.provider === "emergent") {
    return `https://auth.emergentagent.com/?redirect=${encodeURIComponent(origin + "/")}`;
  }
  throw new Error("google_auth_configuration_unavailable");
}

export async function startGoogleSignIn(nextPath) {
  const next = safeNextPath(nextPath);
  const url = await googleSignInUrl(next);
  stashGoogleReturnPath(next);
  window.location.assign(url);
}
